import { put } from 'redux-saga/effects';
import { LocalStorageSaved, LocalStorageSave } from '../actions';

export function* saveToLocalStorage({ payload }: ReturnType<typeof LocalStorageSave>): Generator {
  try {
    if (payload.jwt !== undefined) {
      if (payload.jwt) {
        localStorage.setItem('jwt', payload.jwt);
      } else {
        localStorage.removeItem('jwt');
      }
    }

    if (payload.states !== undefined) {
      if (Object.keys(payload.states).length > 0) {
        localStorage.setItem('states', JSON.stringify(payload.states));
      } else {
        localStorage.removeItem('states');
      }
    }

    yield put(LocalStorageSaved());
  } catch {
    // Игнорируем ошибки localStorage (например, если он отключён)
    yield put(LocalStorageSaved());
  }
}
